import { useQuery } from '@tanstack/react-query';
import type { GetQuoteDocumentsRequestParams } from '@views/screens/Quote/data-provider/quote-documents/api';
import { fetchQuoteDocuments } from '../data-provider/quote-documents';

export const useGetQuoteDocuments = (params: GetQuoteDocumentsRequestParams) => {
  return useQuery({
    queryKey: ['quote-documents', params],
    queryFn: () => fetchQuoteDocuments(params),
    staleTime: 1000 * 5, // 5 seconds (to avoid multiple calls)
    enabled: !!params.quoteKey,
  });
};
